export const ICandidateQualif = Object.freeze({
  qualificationId: "qualification_id",
  qualificationName: "qualification_name",
  isBestQualif: "is_best",
});

export class CandidateQualifModel {
  constructor(data = {}) {
    this[ICandidateQualif.qualificationId] = data[ICandidateQualif.qualificationId];
    this[ICandidateQualif.qualificationName] = data[ICandidateQualif.qualificationName];
    this[ICandidateQualif.isBestQualif] = data[ICandidateQualif.isBestQualif];
  }

  getLabel() {
    return this[ICandidateQualif.qualificationName];
  }

  getId() {
    return this[ICandidateQualif.qualificationId];
  }

  isBestQualif() {
    return this[ICandidateQualif.isBestQualif] === true;
  }
}
